import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss'],
})
export class IconsComponent implements OnInit {
    @Input() icon: IconType;

    @Input() iconString: string;

    constructor() {}

    ngOnInit(): void {}

    getSizeValue(size: string | number): string {
        return typeof size === 'number' ? `${size}px` : size;
    }
}

export type IconType =
    | 'search'
    | 'sort'
    | 'rise'
    | 'filter'
    | 'dashboard'
    | 'triangular-warning'
    | 'naira-symbol'
    | 'wallet'
    | 'receipt'
    | 'power'
    | 'paper'
    | 'settings'
    | 'lock'
    | 'unlock'
    | 'info-circle'
    | 'cash'
    | 'upload-icon'
    | 'credit-box-icon'
    | 'users'
    | 'building'
    | 'overlaped-users'
    | 'location-pin'
    | 'checkmark'
    | 'payout-arrow'
    | 'file'
    | 'devices'
    | 'home'
    | 'piggy-savings'
    | 'question-mark'
    | 'user'
    | 'receipts'
    | 'two-way-arrow'
    | 'button-search'
    | 'wheel'
    | 'person'
    | 'dual-arrow'
    | 'logout'
    | 'colored-wallet'
    | 'circle-plus'
    | 'blue-success'
    | 'copy'
    | 'close'
    | 'half-step'
    | 'quarter-step'
    | 'full-step'
    | 'yellow-success'
    | 'go-back'
    | 'colored-double-previous'
    | 'calendar'
    | 'colored-double-next'
    | 'colored-previous'
    | 'colored-next'
    | 'red-cancel'
    | 'drop-down'
    | 'menu-icon'
    | 'drop-down-select'
    | 'right-direction'
    | 'profile-avatar'
    | 'rolez-icon'
    | 'cashout'
    | 'deposit'
    | 'pay-bills'
    | 'fund-wallet'
    | 'airtime'
    | 'terminals'
    | 'bank-check'
    | 'debit-box-icon'
    | 'blue-calendar'
    | 'disputes'
    | 'outlet-manager'
    | 'agent'
    | 'agent-sm'
    | 'outlet-manager-sm'
    | 'agent-sm-inactive'
    | 'outlet-manager-sm-inactive'
    | 'agent-xs'
    | 'agent-xs-inactive'
    | 'outlet-manager-xs'
    | 'outlet-manager-xs-inactive'
    | 'transactions'
    | 'yellow-error-icon'
    | 'vertical-dots'
    | 'key'
    | 'pricing-tag'
    | 'cash-back'
    | 'empty-card'
    | 'new-card'
    | 'card-bg'
    | 'card-channel'
    | 'card-limit'
    | 'change-card-pin'
    | 'block-card'
    | 'enable-web'
    | 'enable-pos'
    | 'enable-atm'
    | 'carosel-left'
    | 'carosel-right'
    | 'single-card'
    | 'card-menu-icon'
    | 'network-icon'
    | 'single-lg-card'
    | 'open-padlock'
    | 'card-step-I'
    | 'card-step-II'
    | 'card-step-III'
    | 'image-icon'
    | 'agents'
    | 'agent-plus'
    | 'bulk-upload'
    | 'small-filter'
    | 'retrieve-terminal'
    | 'swap-terminal'
    | 'white-wallet'
    | 'small-cashout'
    | 'small-terminal-icon'
    | 'small-manager-icon'
    | 'small-wallet-icon'
    | 'timer'
    | 'ratings'
    | 'pos'
    | 'graph'
    | 'colored-graph'
    | 'mask-group'
    | 'empty-document'
    | 'small-divider'
    | 'reports'
    | 'area-icon'
    | 'union'
    | 'cash-insurance'
    | 'camera-shutter'
    | 'offline-payments'
    | 'plain-circle'
    | 'back-icon'
    | 'empty-state-pos'
    | 'collections'
    | 'paycodes'
    | 'bonanza-divider'
    | 'bonanza-divider-sm'
    | 'account-icon'
    | 'loan'
    | 'performance-img-background'
    | 'bronze-star'
    | 'silver-star'
    | 'gold-star'
    | 'square-checkmark'
    | 'square-cancel'
    | 'stacked-stars-3'
    | 'stacked-stars-2'
    | 'stacked-stars-1'
    | 'poll'
    | 'empty-file-holder'
    | 'filter-icon'
    | 'mini-phone'
    | 'mini-mail'
    | 'mini-id-card'
    | 'mini-next-of-kin'
    | 'alert-icon'
    | 'header-logout'
    | 'header-personal-profile'
    | 'header-user-settings'
    | 'sidebar-accounts'
    | 'sidebar-approvals'
    | 'sidebar-businesses'
    | 'sidebar-loans'
    | 'sidebar-savings'
    | 'sidebar-transactions'
    | 'sidebar-dashboard'
    | 'sidebar-business-owners'
    | 'sidebar-cards'
    | 'sidebar-pos-terminals'
    | 'sidebar-deposits'
    | 'sidebar-dashboard-toggle-hide'
    | 'green-check'
    | 'image-clip'
    | 'green-success-icon'
    | 'blue-circle-user'
    | 'red-failed-icon'
    | 'Nigeria-flag'
    | 'face-capture-icon'
    | 'face-capture-upload-icon'
    | 'circle-file-icon'
    | 'send-icon'
    | 'naira-icon'
    | 'building-grey'
    | 'dropdown-icon-grey'
    | 'caret-right'
    | 'beneficiary-icon'
    | 'moniepoint-logo'
    | 'info-icon'
    | 'avatar'
    | 'beneficiaries-icon'
    | 'transfer-icon'
    | 'airtime-and-data-icon'
    | 'buy-airtime-icon'
    | 'custom-edit-icon'
    | 'grey-lock'
    | 'grey-user'
    | 'grey-eye'
    | 'success-icon'
    | 'progress-icon'
    | 'incomplete-timeline-icon'
    | 'complete-timeline-icon'
    | 'active-timeline-icon'
    | 'inactive-timeline-icon'
    | 'profile-back-icon'
    | 'yellow-bullet-point-icon'
    | 'yellow-warning-icon'
    | 'accept-claim-icon'
    | 'custom-breadcrumb-icon'
    | 'envelop-icon'
    | 'right-direction-lg'
    | 'accept-claim-warning-icon'
    | 'consolidated-success-icon'
    | 'consolidated-logout-icon'
    | 'selection-mode-profile-icon'
    | 'selection-mode-bank-icon'
    | 'notification-bell-icon'
    | 'add-business-icon'
    | 'timer-icon'
    | 'consolidate-profile-icon'
    | 'white-nav-icon'
    | 'face-capture-two'
    | 'profile-failure-icon'
    | 'new-bill-payment-icon'
    | 'white-add-icon'
    | 'view-details-icon'
    | 'red-warning'
    | 'custom-naira-icon'
    | 'moniepoint-sm-logo'
    | 'large-naira-icon'
    | 'blue-info-icon'
    | 'circular-user-icon'
    | 'blue-reload-icon'
    | 'green-lg-success-icon'
    | 'orange-lg-pending-icon'
    | 'red-lg-failed-icon'
    | 'small-green-check-icon'
    | 'recent-transaction-icon'
    | 'recent-airtime-icon'
    | 'airtime-data-airtime-icon'
    | 'airtime-data-data-icon'
    | 'coming-soon-bg-icon'
    | 'big-bank-icon'
    | 'replay-icon'
    | 'mtn-icon'
    | 'airtel-icon'
    | 'glo-icon'
    | 'etisalat-icon'
    | 'icon-representation'
    | 'btn-arrow'
    | 'funds-transfer'
    | 'dispute'
    | 'orange-settings'
    | 'credit'
    | 'empty-wallet'
    | 'debit'
    | 'blue-eye-icon'
    | 'plus-icon'
    | 'blue-arrow-icon'
    | 'trash-icon'
    | 'profile-next-of-kin'
    | 'profile-account'
    | 'profile-profile-limit'
    | 'profile-security'
    | 'profile-certificate'
    | 'new-wallet-naira'
    | 'new-wallet-naira-sm'
    | 'card-issuer-master'
    | 'card-issuer-visa'
    | 'insufficient-wallet'
    | 'card-trans-limit'
    | 'limit-tracker'
    | 'code-pad'
    | 'empty-business-card'
    | 'timer-blue'
    | 'unblock-card'
    | 'scan-qr'
    | 'serial-number'
    | 'right-chevron'
    | 'change-card-pin-II'
    | 'eye-crossed'
    | 'eye-open'
    | 'purchase-insurance-icon'
    | 'swap-icon'
    | 'retrieve-icon'
    | 'ownership-icon'
    | 'attachment-icon'
    | 'transfer'
    | 'tick-sign'
    | 'cross-sign'
    | 'new-sort'
    | 'empty-folder'
    | 'cashout-btn-icon'
    | 'place-pnd-btn-icon'
    | 'mail-btn-icon'
    | 'call-btn-icon'
    | 'card-change-pin'
    | 'card-reset-pin'
    | 'circle-up-arrow'
    | 'circle-down-arrow'
    | 'down-arrow'
    | 'error-state'
    | 'empty-state'
    | 'right-chevron-primary'
    | 'information'
    | 'delete-account'
    | 'arrow-down'
    | 'arrow-up'
    | 'deactivate-icon'
    | 'delete-trash'
    | 'watch-icon'
    | 'moniepoint-sm'
    | 'warning-sm'
    | 'document'
    | 'caret'
    | 'clock'
    | 'users-sm'
    | 'info-sm'
    | 'notice'
    | 'empty-card-carton'
    | 'arrow-right-white';
